import { Entity, EntityWDateAttributes } from "../helpers/Entity"

export type SalesHistoryAttributes = {
    contactId: string
    rowId: string
    saleId: string
    saleType: string
    identifier: string
    transactionDate: Date
}

export type SalesHistoryDto = {
    id: string
    attributes: SalesHistoryAttributes
}

export type SerialNumberAttributes = {
    accountId: string
    serial: string
    productId: string
    salesHistory: SalesHistoryDto[]
} & EntityWDateAttributes

export type SerialNumberDto = {
    id: string
    type: string
    attributes: SerialNumberAttributes
}


export default class SerialNumber implements Entity {
    private dto: SerialNumberDto

    constructor(dto: SerialNumberDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.type === "serial-numbers"
    }

    getId(): string {
        return this.dto.id
    }

    getSerial(): string {
        return this.dto.attributes.serial
    }
}


// WEBPACK FOOTER //
// ./src/state/serial-number/SerialNumber.ts